/**
 * Created by ccczzz on 2020/7/28.
 */
import axios from 'axios'

var reportFilters={

}
export default {
    //获取时间
    getDateStr:function(){
        var day1 = new Date();
        day1.setTime(day1.getTime());
        var s1 = day1.getFullYear()+"年" + (day1.getMonth()+1) + "月" + day1.getDate()+ "日";
        return s1;
    },
    //计算两个日期之间的天数
    calculateIDays:function (startTime,endTime) {
        var strSeparator='-';
        var date1=new Date(startTime);
        var date2=new Date(endTime);
        var iDays=parseInt(Math.abs(date2-date1)/1000/60/60/24);
        return iDays;
    },
    //多选
    multiFilter:function (array,filters) {
       const filterKeys=Object.keys(filters)
       return array.filter(function(item) {
               return filterKeys.every(key => {
                   //ignore when the filter is empty Anne
                   if(!filters[key].length) return true
                    return !!~filters[key].indexOf(item[key])
               })
       })
   },
    //根据关键字筛选 保险公司名称  保单号  产品名称
    searchKeywords:function (array,keyword) {
        var reg=new RegExp(keyword);
        var arr=[];
        for(var i=0;i<array.length;i++){
            var item=array[i];
            // console.log(item);
            var companyName=item.companyName;
            var policyNo=item.policyNo;
            var productName=item.productName;
            if(policyNo.indexOf(keyword)=='0'){
                arr.push(item);
            }else if(reg.test(companyName)||reg.test(productName)){
                arr.push(item);
            }
        }
        return arr;
    },
    //  entryOrExit进入是1 退出是2 modelName模块名称
    recordUserBehavior:function (uuid,entryOrExit,modelName,callback) {
        var currentTime=new Date().getTime();
        var userId=sessionStorage.getItem('userId');
        var phoneSystem=sessionStorage.getItem('phoneSystem');
        if(!phoneSystem||phoneSystem.length==0){
            phoneSystem=this.getBrowserInfo();
        }
        var data={
                id:uuid,
                userId:userId,
                type:'pc',
                modelEntryTime:'',
                modelExitTime:'',
                modelName:modelName,
                phoneSystem:phoneSystem,
        }
        if(entryOrExit=='1'){
            data.modelEntryTime=currentTime;
            data.modelExitTime='';
        }else{
            data.modelEntryTime='';
            data.modelExitTime=currentTime;
        }
        // console.log(JSON.stringify(data));
        var _this=this
        axios({
            url:'/behavior/moduleChange',
            method: 'post',
            data: data
        })
            .then(function (res) {
                if(res.data.code&&res.data.code=='200'){
                    // console.log(res);
                    var uuid=res.data.data.id;
                    callback(uuid);
                }
            })
            .catch(function (error) {
            });
    },
    //生成随机UUID
    getRandomUUID:function () {
        return (this.S4()+this.S4()+"-"+this.S4()+"-"+this.S4()+"-"+this.S4()+"-"+this.S4()+this.S4()+this.S4());
    },
    S4:function () {
        return  (((1+Math.random())*0x10000)|0).toString(16).substring(1);
    },
    //获取当前浏览器版本号
    getBrowserInfo:function(){
        var Sys = {};
        var ua = navigator.userAgent.toLowerCase();
        var re =/(msie|firefox|chrome|opera|version).*?([\d.]+)/;
        var m = ua.match(re);
        if(m&&m.length>0){
            Sys.browser = m[1].replace(/version/, "'safari");
            if(m.length>1){
                Sys.ver = m[2];
            }else{
                Sys.ver='0';
            }
            var phoneSystem=Sys.browser+'-'+Sys.ver;
            sessionStorage.setItem('phoneSystem',phoneSystem);
        }else{
            sessionStorage.setItem('phoneSystem','ie');
        }
        return phoneSystem;
    },
    // getImageUrl:function (){
    //     return 'http://210.12.38.206/gateway/Xfzfwpt';
    // }
    getImageUrl:function (){
            //获取当前网址，
            // window.location.host
            var curWwwPath=window.document.location.href;
            //获取主机地址之后的目录，
            var pathName=window.document.location.pathname;
            var pos=curWwwPath.indexOf(pathName);
            //获取主机地址，
             if(pos){
                 var localhostPath=curWwwPath.substring(0,pos);
                 if(localhostPath!='http:'&&localhostPath!='https:'){
                     return(localhostPath+"/gateway/Xfzfwpt");
                 }else{
                     var hos=window.location.host;
                     return (localhostPath+'//'+hos+"/gateway/Xfzfwpt")
                 }
             }
             else{
                 return '';
             }
    },
    getIdentityType:function (typeStr){
        if(typeStr=='111'){
            return "居民身份证"
        }else if(typeStr=='113'){
            return "户口薄"
        }else if(typeStr=='114'){
            return "中国人民解放军军官证"
        }else if(typeStr=='414'){
            return "普通护照"
        }else if(typeStr=="511"){
            return "台湾居民来往大陆通行证"
        }else if(typeStr=="516"){
            return "港澳同胞回乡证(通行卡)"
        }else if(typeStr=='112'){
            return "临时居民身份证"
        }else if(typeStr=='115'){
            return "中国人民武装警察部队警官证"
        }else if(typeStr=="117"){
            return "出生医学证明"
        }else if(typeStr=="121"){
            return "法官证"
        }else if(typeStr=='123'){
            return "警官证"
        }else if(typeStr=='125'){
            return "检察官证"
        }else if(typeStr=='127') {
            return "律师证"
        }else if(typeStr=='128') {
            return "记者证"
        }else if(typeStr=='131') {
            return "工作证"
        }else if(typeStr=='133') {
            return "学生证"
        }else if(typeStr=='211') {
            return "离休证"
        }else if(typeStr=='213') {
            return "老年证"
        }else if(typeStr=='217') {
            return "残疾证"
        }else if(typeStr=='219') {
            return "结婚证"
        }else if(typeStr=='221') {
            return "离婚证"
        }else if(typeStr=='223') {
            return "独生子女证"
        }else if(typeStr=='225') {
            return "毕业证书"
        }else if(typeStr=='227') {
            return "肄业证"
        }else if(typeStr=='229') {
            return "结业证"
        }else if(typeStr=='231') {
            return "学位证"
        }else if(typeStr=='335') {
            return "机动车驾驶证"
        }else if(typeStr=='411') {
            return "公务护照"
        }else if(typeStr=='413') {
            return "因公普通护照"
        }else if(typeStr=='417') {
            return "外国人出入境证"
        }else if(typeStr=='418') {
            return "外国人旅行证"
        }else if(typeStr=='417') {
            return "外国人出入境证"
        }else if(typeStr=='419') {
            return "海员证"
        }else if(typeStr=='420') {
            return "香港特别行政区护照"
        }else if(typeStr=='421') {
            return "澳门特别行政区护照"
        }else if(typeStr=='423') {
            return "澳门特别行政区旅行证"
        }else if(typeStr=='513') {
            return "往来港澳通行证"
        }else if(typeStr=='515') {
            return "前往港澳通行证"
        }else if(typeStr=='517') {
            return "大陆居民往来台湾通行证"
        }else if(typeStr=='518') {
            return "因公往来香港澳门特别行政区通行证"
        }else if(typeStr=='551') {
            return "华侨回归定居证"
        }else if(typeStr=='552') {
            return "台湾居民定居证"
        }else if(typeStr=='553') {
            return "外国人永久居留证"
        }else if(typeStr=='554') {
            return "外国人居留证"
        }else if(typeStr=='555') {
            return "外国人临时居留证"
        }else if(typeStr=='556') {
            return "入籍证书"
        }else if(typeStr=='557') {
            return "出籍证书"
        }else if(typeStr=='558') {
            return "复籍证书"
        }else if(typeStr=='990') {
            return "其他"
        }else{
            return "其他"
        }
    },
}

